require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./trying-a-different-voice.json") })
        }
      }, "path---trying-a-different-voice");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---trying-a-different-voice!./.cache/json/trying-a-different-voice.json
// module id = 578
// module chunks = 231608221292675